import React from "react";
import PropTypes from "prop-types";

export function URLToHref({ children, url, params, ...props }) {
  const prefix = (p, s) => {
    return s ? p + s : "";
  };

  return (
    <strong>
      <a
        href={`${url}${prefix("?", params)}`}
        rel="noopener noreferrer"
        {...props}
      >
        {children}
      </a>
    </strong>
  );
}

URLToHref.propTypes = {
  children: PropTypes.node.isRequired,
  url: PropTypes.string.isRequired,
  params: PropTypes.string,
};

URLToHref.defaultProps = { params: undefined };

export default URLToHref;
